import { memo, useCallback, useState } from "react";
import { Group } from "@mantine/core";
import {
  GetLocationsQuery,
  GetOrganizationServiceQuery,
  useGetLocationsQuery,
} from "src/generated/graphql";
import CreateLocationService from "./CreateLocationService";
import { useModals } from "@mantine/modals";
import { useParams } from "react-router-dom";
import ActionCard from "src/components/ActionCard";
import LocationServiceDetail from "./LocationServiceDetail";

export interface IPropsLocationService {
  locationServices: NonNullable<
    GetOrganizationServiceQuery["organizationServiceOne"]
  >["locationServices"];
  filterLocations?: GetLocationsQuery["locationMany"] | undefined;
  handleGetOrganizationService: () => void;
  isAllowWrite: boolean;
}

function LocationService({
  locationServices,
  handleGetOrganizationService,
  isAllowWrite,
}: IPropsLocationService) {
  const { data } = useGetLocationsQuery();
  const [visibleCards, setvisibleCards] = useState<string[]>([]);
  const modals = useModals();
  const { serviceId } = useParams<{ serviceId: string }>();

  const handleModal = useCallback(() => {
    const _locServiceIds = locationServices.map((e) => e.location.id);
    const filterLocation = data?.locationMany.filter(
      (e) => !_locServiceIds.includes(e.id)
    );

    modals.openModal({
      closeOnClickOutside: false,
      title: "Create Location Service",
      children: (
        <CreateLocationService
          serviceId={serviceId}
          filterLocations={filterLocation}
          handleGetOrganizationService={handleGetOrganizationService}
        />
      ),
    });
  }, [data?.locationMany, serviceId, locationServices]);

  return (
    <>
      <Group position="apart" mt="lg" mb="sm">
        <ActionCard
          title="Locations"
          handleModal={isAllowWrite ? handleModal : undefined}
        >
          {locationServices.map((e) => (
            <LocationServiceDetail
              visibleCards={visibleCards}
              setvisibleCards={setvisibleCards}
              handleGetOrganizationService={handleGetOrganizationService}
              detail={e}
              key={e.id}
              isAllowWrite={isAllowWrite}
            />
          ))}
        </ActionCard>
      </Group>
    </>
  );
}

export default memo(LocationService);
